// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OrcamentosServicos_SelectserviciosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /orcamentos_servicos/selectServicos
 *
 * Returns a list of services with their categories for frontend selection.
 */
import type { OrcamentosServicos_SelectserviciosRow } from './OrcamentosServicos_SelectserviciosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OrcamentosServicos_SelectserviciosResponseDados = OrcamentosServicos_SelectserviciosRow[];

export type OrcamentosServicos_SelectserviciosResponse = ApiResponse<OrcamentosServicos_SelectserviciosResponseDados>;

registerResponseContract('OrcamentosServicos_SelectserviciosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servico_id:                            { type: 'number',  required: true },
      servico_nome:                          { type: 'string',  required: true },
      servico_valor_padrao:                  { type: 'number',  required: true },
      servicoscategoria_id:                  { type: 'string',  required: true },
      servicocategoria_id:                   { type: 'string',  required: true },
      servicoscategoria_nome:                { type: 'string',  required: true },
      servicoscategoria_prazo_retorno_dias:  { type: 'number',  required: true },
      servicoscategoria_prazo_garantia_dias: { type: 'number',  required: true },
      servicoscategoria_produtos_associados: { type: 'number',  required: true },
      nome:                                  { type: 'string',  required: true },
      background_color:                      { type: 'string',  required: false },
    },
  },
})
